import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled.section`
	--grid-template-columns: 1fr 15rem 15rem 11rem 7rem 17rem 18rem 2rem;
	--grid-template-rows: 4rem;

	@media screen and (min-width: 1800px) {
		--grid-template-columns: 1fr 20rem 20rem 18rem 15rem 18rem 18rem 2rem;
	}

	/* Used for the msTeams component */
	--color: ${({theme}) => theme.color.grey500};
	--line2-color: ${({theme}) => theme.color.grey400};
	/* ... */
	button {
		padding: 0;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
	hr {
		margin: 0;
		border-top: var(--table--border-style) var(--table--border-width) var(--table--border-color);
	}

	.team {
		.show-pop-content {
			&.top {
				&.right {
					right: -1rem;
					.show-popup-arrow {
						right: 1.5rem;
					}
				}
			}
		}
		display: none;
		&.visible {
			display: block;
		}
		.StyledPopOver {
			width: 1.8rem;
			.show-pop-content {
				transition: left 1s;
			}
		}
		.custom-tooltip {
			width: 1.8rem;
		}
		.teamMembersOptionButton {
			.btnTitle {
				white-space: nowrap;
			}
			.showPopupWrapper button {
				width: 100%;
				text-align: initial;
				padding: 1rem 3rem 1rem 1rem;
				&:hover {
					background: ${(props) => props.theme.color[`grey200`]};
				}
			}
			.disabled {
				cursor: default !important;
				svg {
					cursor: default !important;
				}
			}
		}
		// .team-data {			
		// 	& > span {
		// 		margin-left: 0.5rem;
		// 	}
		// }
		.team-children {
			padding-left: 2rem;
			position: relative;
			&:before {
				content: '';
				width: 0.2rem;
				height: calc(100% - 2rem);
				border-width: 0 0 0 0.2rem;
				border-color: ${({theme}) => theme.color.grey300};
				border-style: dashed;
				position: absolute;
				top: -1rem;
				left: 2.5rem;
			}
			.team-data {
				position: relative;
				&:before {
					content: '';
					width: 0.9rem;
					height: 0.2rem;
					border-width: 0 0 0.2rem 0;
					border-color: ${({theme}) => theme.color.grey300};
					border-style: dashed;
					position: absolute;
					left: 0.5rem;
					bottom: 50%;
				}
				// & > span {
				// 	margin-left: 0.5rem;
				// }
			}
		}
		&.last {
			.team-children {
				&:after {
					content: '';
					width: 0.2rem;
					height: 100%;
					border-color: ${({theme}) => theme.color.grey100};
					border-style: solid;
					border-width: 0 0 0 0.2rem;
					position: absolute;
					top: -3rem;
					left: 0.5rem;					
					visibility: hidden;
				}
			}
		}
	}

	.tooltip-content
`;
export const OutputTextMessage = styled(OutputText)`
	min-height: ${({minHeight = '25vh'}) => minHeight};
	display: flex;
	align-items: center;
	justify-content: center;
`;
